"use client";

import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

interface BackToTopProps {
  /** 滚动多少像素后显示按钮，默认 300 */
  showAfter?: number;
  /** 按钮位置，默认右下角 */
  position?: "bottom-right" | "bottom-left";
}

export default function BackToTop({
  showAfter = 300,
  position = "bottom-right"
}: BackToTopProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > showAfter) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, [showAfter]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const positionClasses = position === "bottom-right"
    ? "right-6 md:right-8"
    : "left-6 md:left-8";

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className={`fixed bottom-6 md:bottom-8 ${positionClasses} z-50
            w-12 h-12 rounded-full
            bg-zinc-900 hover:bg-zinc-800
            text-white
            shadow-lg hover:shadow-xl
            transition-all duration-300
            flex items-center justify-center
            group
            animate-in fade-in slide-in-from-bottom-4`}
          aria-label="返回顶部"
        >
          <ChevronUp
            className="w-5 h-5 group-hover:-translate-y-0.5 transition-transform"
          />
        </button>
      )}
    </>
  );
}

